import { el, setAttr } from 'redom';

import { stringToSVG } from 'utilities';
import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import Options from './list';

import dropDownClosedIconString from 'assets/images/expand-right-icon.svg?raw';

import './index.scss';

const dropDownClosedIcon = stringToSVG(dropDownClosedIconString);

class DefaultPrimaryContentView {

  constructor(name) {

    this.el = el('span', name);

  }

}

class SimpleMenu {

  constructor(configuration) {

    this.PrimaryContentView = configuration.PrimaryContentView || DefaultPrimaryContentView;
    this.optionClickHandler = null;
    this.optionsDisplaySide = configuration.optionsDisplaySide || 'right';

    this.optionsList = new Options({
      ItemView: configuration.ItemView,
      options: configuration.options,
      onSelect: this.handleOptionSelect.bind(this)
    });

    this.el = el('.simple-menu-main', {
      id: configuration.id || performance.now(),
      onmouseenter: this.handleMouseEnter.bind(this),
      onmouseleave: this.handleMouseLeave.bind(this)
    }, [
      el('.primary-content', {
        class: this.optionsDisplaySide
      }, [
        new this.PrimaryContentView(configuration.name),
        dropDownClosedIcon.cloneNode(true)
      ]),
      el('.secondary-content', [this.optionsList])
    ]);

  }

  showOptions() {

    const element = this.optionsList.el;
    const anchorElement = this.el;
    const viewportElement = void 0;
    const verticalOffset = 0;
    const horizontalOffset = 0;
    const startSide = this.optionsDisplaySide;
    const placeOnCenter = true;
    const positionableSides = [this.optionsDisplaySide];

    setAttr(element, {
      style: {
        display: 'flex'
      }
    });

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  hideOptions() {

    setAttr(this.optionsList.el, {
      style: {
        display: 'none'
      }
    });

  }

  handleMouseEnter() {

    this.showOptions();

  }

  handleMouseLeave() {

    this.hideOptions();

  }

  handleOptionSelect(event, option) {

    this.optionClickHandler(event, option);

  }

  registerClickEvent(handler) {

    this.optionClickHandler = handler;

  }

}

export default SimpleMenu;